import {useAppDispatch, useAppSelector} from "../redux/stateHooks";
import {ListItemTransactionType} from "../definitions/types";
import {clearListItemTransaction, setListItemTransaction} from "../redux/slices/listItemTransaction";
import {useEffect} from "react";

export const useListItemTransactionState = () => {
    const dispatch = useAppDispatch();
    const state = useAppSelector((state) => state.listItemTransaction.value);

    // Clear the completed transaction state after a few seconds
    useEffect(() => {
        if (!state) return;
        const timeoutId = setTimeout(() => dispatch(clearListItemTransaction()), 5000);
        return () => clearTimeout(timeoutId);
    }, [state]);

    return {
        state,
        set: (payload: ListItemTransactionType) => dispatch(setListItemTransaction(payload)),
        clear: () => dispatch(clearListItemTransaction())
    };
}